import gql from 'graphql-tag';
import apollo from 'src/features/apolloSecure';

const mutation = gql`
mutation clearUploads($activityId: ID!, $isDepartment: Boolean) {
  clearUploads(activityId: $activityId, isDepartment: $isDepartment)
}`;

function clearUploads(activityId, isDepartment = false) {
  return apollo.client.mutate({
    mutation,
    variables: {
      activityId,
      isDepartment,
    },
  }).then((data) => data.data.clearUploads);
}

export default clearUploads;
